import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WatchTimerComponent } from './bdb-watch-timer.component';

/*
 * Modulo de watch timer
 * @author Iarteaga
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [WatchTimerComponent],
  exports: [WatchTimerComponent]

})
export class WatchTimerModule { }



// WEBPACK FOOTER //
// ./src/app/bdb-watch-timer/bdb-watch-timer.module.ts